module.exports = __webpack_public_path__ + "img/150.12886b56.jpg";